// Print an HTML document through a hidden iframe — shows the browser's print
// dialog directly on the current page (no new tab that flashes open/closed).
export function printHtmlViaIframe(html) {
  const iframe = document.createElement("iframe");
  iframe.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden;";
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(html);
  doc.close();
  const win = iframe.contentWindow;
  const cleanup = () => setTimeout(() => { try { iframe.remove(); } catch { /* noop */ } }, 500);
  win.onafterprint = cleanup;
  setTimeout(() => {
    try { win.focus(); win.print(); } catch { cleanup(); }
  }, 250);
  setTimeout(cleanup, 120000);
}
